<div class="summary-panel">
  <div class="summary-body" #summaryBody>
    <!-- Section 1: Captured Tables -->
    <div class="section">
      <h3 class="section-title-captured" [class.has-subtitle]="coreStatements.length > 0">Captured for Spreading: {{ coreStatements.length }}</h3>
      @if (coreStatements.length > 0) {
        <p class="section-subtitle-captured">Tables with the same classification will be merged in {{mergeStepLabel}}</p>
      }

            <div class="table-card"
                 *ngFor="let card of coreStatements"
                 [class.selected]="card.table.sourcePageNumber === activePageIndex"
                 [class.active-table]="card.table === selectedTable"
                 [class.card-type-other]="!card.isCoreStatement"
                 (click)="onCardClick(card, $event)"
            >
                <div class="card-icon" [class.core-icon]="card.isCoreStatement" [class.additional-icon]="!card.isCoreStatement">
                    <i [class]="getStatementIcon(card.statementType)"></i>
                </div>
                <div class="card-info">
                    <div class="card-title">{{ card.displayName }}</div>
                    <div class="card-meta">Pg {{ card.pageNumber }}<!-- <ng-container *ngIf="card.isCoreStatement"><span class="meta-separator">&middot;</span>Additional Notes: {{ card.additionalNotesCount }}</ng-container> --></div>
                </div>
                <div class="card-actions">
                    <!-- Classified tables: reclassify button -->
                    <ng-container *ngIf="card.isCoreStatement">
                        <ng-container *ngIf="reclassifyingCardId !== card; else reclassifyDropdown">
                            <button class="btn-action btn-reclassify" (click)="toggleReclassify(card)">
                                <i class="fas fa-arrows-rotate"></i> Reclassify
                            </button>
                        </ng-container>
                        <ng-template #reclassifyDropdown>
                            <div class="classify-group">
                                <span class="classify-icon-box"><i class="fas fa-arrows-rotate"></i></span>
                                <select class="form-select" (change)="onReclassifyAs(card, $event)" (blur)="cancelReclassify()">
                                    <option value="" selected>Reclassify as...</option>
                                    <option *ngFor="let opt of RECLASSIFY_OPTIONS" [value]="opt.value">
                                        {{ opt.label }}
                                    </option>
                                </select>
                            </div>
                        </ng-template>
                    </ng-container>
                    <!-- Unclassified tables: classify dropdown -->
                    <ng-container *ngIf="!card.isCoreStatement">
                        <div class="classify-group">
                            <span class="classify-icon-box"><i class="fas fa-arrows-rotate"></i></span>
                            <select class="form-select" (change)="onClassifyAs(card, $event)">
                                <option value="" selected>Classify as...</option>
                                <option *ngFor="let opt of STATEMENT_TYPE_OPTIONS" [value]="opt.value">
                                    {{ opt.label }}
                                </option>
                            </select>
                        </div>
                    </ng-container>
                    <button class="btn-action btn-view" (click)="onViewTable(card)">
                        View <i class="fas fa-arrow-right"></i>
                    </button>
                </div>
            </div>

      @if (coreStatements.length === 0 && additionalTables.length === 0) {
        <div class="comprehensive-empty-state">
          <div class="comprehensive-empty-icon">
            <i class="fas fa-magnifying-glass"></i>
          </div>
          <p class="comprehensive-empty-heading">No tables captured</p>
          <div class="comprehensive-empty-section">
            <p class="section-header">To add tables manually:</p>
            <ol class="instruction-list">
              <li>Search by keyword or scroll, then select a page</li>
              <li>Click and drag to draw a box around the content on the selected page</li>
              <li>Classify it as part of the Income Statement, Balance Sheet, or Cash Flow Statement</li>
            </ol>
          </div>
          <div class="comprehensive-empty-section">
            <p class="section-header">If this seems unexpected:</p>
            <ul class="troubleshooting-list">
              <li>Make sure the document is readable - if not, then tables can't be detected</li>
              <li>If this is a tax return, select "Tax Return" as the statement type during upload</li>
            </ul>
          </div>
        </div>
      }

      @if (coreStatements.length === 0 && additionalTables.length > 0) {
        <div class="compact-empty-banner">
          <div class="compact-banner-icon">
            <i class="fas fa-circle-exclamation"></i>
          </div>
          <div class="compact-banner-content">
            <p class="compact-banner-heading">No tables classified</p>
            <p class="compact-banner-description">To spread this document, at least one table must be classified as an Income Statement, Balance Sheet, or Cash Flow Statement. Use the "Classify as..." dropdown on any table below to get started.</p>
          </div>
        </div>
      }
    </div>

        <!-- Section 2: Optional Tables for Classification -->
        <div class="section" *ngIf="additionalTables.length > 0 || coreStatements.length > 0">
            <h3 class="section-title-additional">Optional Tables for Classification: {{ additionalTables.length }}</h3>

            <ng-container *ngIf="additionalTables.length > 0; else optionalEmptyState">
                <p class="section-description">Tables below this line are not yet included in the spread. To include a table, classify it as part of the Income Statement, Balance Sheet, or Cash Flow Statement.</p>

                <div class="table-card"
                     *ngFor="let card of additionalTables"
                     [class.selected]="card.table.sourcePageNumber === activePageIndex"
                     [class.active-table]="card.table === selectedTable"
                     [class.card-type-other]="true"
                     (click)="onCardClick(card, $event)"
                >
                    <div class="card-icon additional-icon">
                        <i [class]="getStatementIcon(card.statementType)"></i>
                    </div>
                    <div class="card-info">
                        <div class="card-title">{{ card.displayName }}</div>
                        <div class="card-meta">Pg {{ card.pageNumber }}</div>
                    </div>
                    <div class="card-actions">
                        <div class="classify-group">
                            <span class="classify-icon-box"><i class="fas fa-arrows-rotate"></i></span>
                            <select class="form-select" (change)="onClassifyAs(card, $event)">
                                <option value="" selected>Classify as...</option>
                                <option *ngFor="let opt of STATEMENT_TYPE_OPTIONS" [value]="opt.value">
                                    {{ opt.label }}
                                </option>
                            </select>
                        </div>
                        <button class="btn-action btn-view" (click)="onViewTable(card)">
                            View <i class="fas fa-arrow-right"></i>
                        </button>
                    </div>
                </div>
            </ng-container>

            <ng-template #optionalEmptyState>
                <div class="optional-empty-state">
                    <div class="optional-empty-icon">
                        <i class="fas fa-magnifying-glass"></i>
                    </div>
                    <p class="optional-empty-header">Additional tables such as notes and schedules can be captured in the document on the left</p>
                    <div class="optional-empty-steps">
                        <p>1. Search by keyword or scroll, then select a page</p>
                        <p>2. Click and drag to draw a box around the content on the selected page</p>
                        <p>3. Classify it as part of the Income Statement, Balance Sheet, or Cash Flow Statement</p>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>
